"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useField_1 = require("../../hooks/useField");
var Checkbox_1 = require("../Checkbox");
var Text_1 = __importDefault(require("../Text"));
var ErrorMessage_1 = __importDefault(require("./common/ErrorMessage"));
var StyledCheckbox = (0, styled_components_1.default)(Checkbox_1.Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  user-select: none;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  user-select: none;\n"])));
var LabelContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: left;\n"], ["\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: left;\n"])));
var Label = (0, styled_components_1.default)(Text_1.default).attrs({ size: 14 })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var CheckboxField = function (props) {
    var label = props.label, name = props.name, children = props.children;
    var _a = (0, useField_1.useField)(__assign(__assign({}, props), { type: "checkbox" })), field = _a[0], meta = _a[1];
    var error = meta.error, touched = meta.touched;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledCheckbox, __assign({}, field, { checked: !!field.value, id: name, noCheckViaLabel: !!children }),
            react_1.default.createElement(LabelContainer, null,
                react_1.default.createElement(Label, null, children || label))),
        error && touched ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null));
};
exports.default = CheckboxField;
var templateObject_1, templateObject_2, templateObject_3;
